<template>
   <b-card v-if="!noBusinessComponent" style="margin-bottom: 2rem">
      <div class="d-flex align-items-center justify-content-between">
         <h2 class="mb-0">Cloud Computing</h2>

         <div class="d-flex align-items-center">
            <span id="cloud-computing-declaration" class="mr-2">{{ declarationStr }}</span>
            <b-button
               id="btn-cloud-computing"
               variant="primary"
               :to="$clientStaffRoute({name: 'cloud-table', params: {id: $companyId}})"
            >
               View
            </b-button>
         </div>
      </div>
   </b-card>

   <CollapseCard v-else title="Cloud Computing" ident="cloud-computing">
      <template #subtitle>
         <span class="text-danger"> Not Configured </span>
      </template>
      <b-alert :show="true" variant="primary" class="m-3">
         <p>Cloud computing have not been fully configured.</p>
         <p class="mb-0">
            <b> This company has no R&D business components associated with an open study. </b>
         </p>
      </b-alert>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: {
      noBusinessComponent: {
         type: Boolean,
      },
   },

   computed: {
      ...mapGetters({
         declaration: 'cloud/declaration',
      }),

      declarationStr() {
         switch (this.declaration) {
            case null:
               return 'No Declaration';
            case true:
               return 'Used Cloud Computing';
            case false:
               return 'No Cloud Computing';
         }
         return 'Unconfigured';
      },
   },
};
</script>
